// removed by extract-text-webpack-plugin
module.exports = {"pageWrapper":"_14Vsd04j4ZCvNHI_fSGrfq","title":"_2xaUE7exLv2wvnPXYmp-FU","titles":"_1wWCcfZ7q67MocAhwCwO38","rightCol":"yD9TnHcU9v4uN6Cby-OoD","savedSearches":"RlQtsKm3kRfdoxkosdMjS","spinner":"_2EdoDu4bw2KLF3ZSScsgRZ","spinnerPosition":"_1mAVnJyrDzF3qfA7EFqZ0k"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/SavedSearches/SavedSearches.scss
// module id = 1849
// module chunks = 0